import * as React from "react"
import { VictoryAxis, VictoryBar, VictoryChart, VictoryTooltip, VictoryLabel } from "victory"
import { theme } from "../../theme"
import { Hidden, Visible } from "react-grid-system"
import ColumnChartMobile from "./ColumnChartMobile"

export interface ColumnChartProps {
  data: Array<any>
  labels: Array<string>
  columnWidth: number
  fullLabels?: Array<string>
  onClickColumnInChart?: (fromDate: any) => void
  width?: number
  animate?: boolean
}

const ColumnChart: React.FunctionComponent<ColumnChartProps> = ({
  data,
  labels,
  columnWidth,
  onClickColumnInChart,
  width = 1000,
  animate = false,
}) => {
  const getYAxisTickLabelNumbers = (value: number) => {
    return value < 1 ? 0 : value / 1000
  }

  const onClickColumn = (index: number) => {
    onClickColumnInChart && onClickColumnInChart(data[index].fromTimestamp)
  }

  return (
    <>
      <Hidden xs>
        <VictoryChart domainPadding={20} animate={animate === true ? { duration: 300 } : false} width={width}>
          <VictoryAxis
            tickFormat={labels}
            labelComponent={<VictoryLabel style={{ fontFamily: "Inter" }} />}
            fixLabelOverlap
            style={{
              tickLabels: {
                fontSize: 10,
                stroke: theme.colors.greyDark,
                color: theme.colors.greyDark,
                fontFamily: "Inter",
                fontWeight: 100,
              },
            }}
          />
          <VictoryAxis
            dependentAxis
            tickFormat={(x) => `${getYAxisTickLabelNumbers(x)}GB`}
            labelComponent={<VictoryLabel style={{ fontFamily: "Inter", fontSize: 10 }} />}
            style={{
              tickLabels: {
                fontSize: 10,
                stroke: theme.colors.greyDark,
                fontFamily: "Inter",
                color: theme.colors.greyDark,
                fontWeight: "thin",
              },
            }}
          />
          <VictoryBar
            style={{
              data: { fill: theme.colors.blue, width: columnWidth },
              labels: { fill: theme.colors.greyDark, fontSize: 8 },
            }}
            labelComponent={
              <VictoryTooltip
                flyoutStyle={{
                  fill: theme.colors.yellow,
                  opacity: 0.8,
                  stroke: "1px solid #616161",
                  color: theme.colors.greyDark,
                }}
              />
            }
            data={data}
            x="time"
            y="dataUsage"
            cornerRadius={5}
            events={[
              {
                target: "data",
                eventHandlers: {
                  onMouseOver: (event, data) => {
                    return [
                      {
                        target: "labels",
                        mutation: () => ({ active: true }),
                      },
                    ]
                  },
                  onMouseOut: () => {
                    return [
                      {
                        target: "labels",
                        mutation: () => ({ active: false }),
                      },
                    ]
                  },
                  onClick: (event, data) => {
                    onClickColumn(data.index)
                  },
                },
              },
            ]}
          />
        </VictoryChart>
      </Hidden>
      <Visible xs>
        <ColumnChartMobile
          data={data}
          labels={labels}
          columnWidth={16}
          onClickColumnInChart={onClickColumnInChart}
          animate={animate}
        />
      </Visible>
    </>
  )
}

export default ColumnChart
